import React, { useEffect, useRef } from "react";
import {
  Bell,
  // CheckCheck,
  Clock,
} from "lucide-react";
import { useNotification } from "../context/NotificationContext";
// import { useUser } from "../context/UserContext";
// import { INotification } from "../api/NotificationApi";
import { CircleCheck } from "lucide-react";

type NotificationDrawerProps = {
  open: boolean;
  onClose: () => void;
};

const formatTimeAgo = (dateStr?: string) => {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHours = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffSec < 60) return "Just now";
    if (diffMin < 60) return `${diffMin}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return "Yesterday";
    if (diffDays < 7) return `${diffDays}d ago`;

    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
    });
  } catch {
    return dateStr;
  }
};

const NotificationDrawer = ({ open, onClose }: NotificationDrawerProps) => {
  const {
    notifications,
    loading,
    loadingMore,
    hasMore,
    loadMore,
    resetLimit,
    markLoadedAsRead,
  } = useNotification();

  // const { user } = useUser();
  // const currentUserId = user?.user?.id ? Number(user.user.id) : null;

  // When drawer is open, automatically mark currently loaded unread notifications as read
  useEffect(() => {
    if (open) {
      markLoadedAsRead();
    }
  }, [open, markLoadedAsRead]);

  // Reset limit back to 50 whenever the drawer is closed
  const prevOpenRef = useRef(open);
  useEffect(() => {
    if (prevOpenRef.current && !open) {
      resetLimit();
    }
    prevOpenRef.current = open;
  }, [open, resetLimit]);

  const handleClose = () => {
    resetLimit();
    onClose();
  };

  // const isNotificationUnread = (item: INotification) => {
  //   if (!currentUserId) return false;
  //   const readList = Array.isArray(item.readBy) ? item.readBy.map(Number) : [];
  //   return !readList.includes(currentUserId);
  // };

  return (
    <>
      {open && (
        <div className="notification-backdrop" onClick={handleClose}></div>
      )}

      <div className={`notification-drawer ${open ? "show" : ""}`}>
        <div className="notification-header">
          <div className="d-flex align-items-center gap-2">
            <h5 className="fw-bold mb-0">Notifications</h5>
            {/* {unreadCount > 0 && (
              <span
                className="badge rounded-pill"
                style={{
                  fontSize: "11px",
                  background: "var(--primary-color)",
                }}
              >
                {unreadCount} new
              </span>
            )} */}
          </div>

          <div className="d-flex align-items-center gap-2">
            {/* {unreadCount > 0 && (
              <button
                type="button"
                className="btn btn-sm btn-link text-decoration-none p-0 d-flex align-items-center gap-1"
                style={{ fontSize: "12px", color: "var(--primary-color)" }}
                onClick={() => markAllAsRead()}
                title="Mark all as read"
              >
                <CheckCheck size={14} />
                <span>Mark all read</span>
              </button>
            )} */}

            <button
              type="button"
              className="btn btn-sm p-1 text-muted"
              onClick={handleClose}
              title="Close"
            >
              <i className="fa-solid fa-xmark fs-6"></i>
            </button>
          </div>
        </div>

        <div className="notification-body custom-scrollbar">
          {loading && notifications.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <div
                className="spinner-border spinner-border-sm mb-2"
                style={{ color: "var(--primary-color)" }}
                role="status"
              ></div>
              <p className="small mb-0">Loading notifications...</p>
            </div>
          ) : notifications.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <Bell size={40} className="mb-2 text-secondary opacity-50" />
              <p className="fw-medium mb-1">No notifications yet</p>
              <small className="text-muted">
                You will receive updates here when activities occur.
              </small>
            </div>
          ) : (
            <>
              {notifications.map((item) => {
                // const unread = isNotificationUnread(item);

                return (
                  // <div
                  //   key={item.id}
                  //   className={`notification-item ${unread ? "unread" : ""}`}
                  // >
                  //   <div className="d-flex align-items-start gap-2">
                  //     <div className="mt-1 flex-shrink-0">
                  //       {unread && (
                  //         <div
                  //           style={{
                  //             width: "8px",
                  //             height: "8px",
                  //             borderRadius: "50%",
                  //             backgroundColor: "var(--primary-color)",
                  //           }}
                  //         />
                  //       )}
                  //     </div>

                  //     <div className="flex-grow-1 overflow-hidden">
                  //       <div className="notification-text fs-small mb-1 text-break">
                  //         {item.message}
                  //       </div>

                  //       <div className="d-flex align-items-center justify-content-between mt-1 flex-wrap gap-1">
                  //         {item.sender ? (
                  //           <span className="notification-sender">
                  //             By: {item.sender}
                  //           </span>
                  //         ) : (
                  //           <span />
                  //         )}

                  //         {item.createdAt && (
                  //           <span className="notification-time d-flex align-items-center gap-1">
                  //             <Clock size={11} />
                  //             {formatTimeAgo(item.createdAt)}
                  //           </span>
                  //         )}
                  //       </div>
                  //     </div>
                  //   </div>
                  // </div>
                  <div
                    key={item.id}
                    className="d-flex align-items-center gap-2 mb-4 justify-content-between"
                  >
                    <div className="d-flex align-items-center">
                      <CircleCheck size={20} className="me-2 text-success" />
                      <span>{item.message}</span>
                    </div>
                    {item.createdAt && (
                      <span
                        className="notification-time d-flex align-items-center gap-1"
                        style={{ fontSize: "10px", whiteSpace: "nowrap" }}
                      >
                        <Clock size={10} />
                        {formatTimeAgo(item.createdAt)}
                      </span>
                    )}
                  </div>
                );
              })}

              {/* Read More button at bottom */}
              {hasMore ? (
                <div className="text-center py-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-badge text-main-color px-4 py-2"
                    onClick={loadMore}
                    disabled={loadingMore}
                  >
                    {loadingMore ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          style={{ color: "var(--primary-color)" }}
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </>
                    ) : (
                      "Read More"
                    )}
                  </button>
                </div>
              ) : (
                <div
                  className="text-center py-3 text-muted"
                  style={{ fontSize: "12px" }}
                >
                  No more notifications
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationDrawer;
